import React from 'react';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import cs from 'classnames';

const NoData = ({ classes, className }) => <div className={cs(classes.root, className)}>No work is done</div>;

export default withStyles(styles)(NoData);
